import { createSelector } from 'reselect';

const projectDeleteData = state => state.projectDeletePopupData;

export const isProjectDeletePopupOpenedSelector = createSelector(
    projectDeleteData,
    (popupData) => popupData.isOpened,
);
